<template>
  <article class="  card-categorei ">
    <router-link
      :to="`/products/category/${data.id}${data.slug ? '/' + data.slug : ''}`"
    >
      <figure
        class="w-100 h-100 m-0 overflow-hidden d-flex justify-content-center"
      >
        <img
          class="w-100 h-100"
          :src="data.icon ? data.icon.url : ''"
          :alt="data.title"
        />
      </figure>
      <h4 class="card-categorei-title">
        {{ data.title }}
      </h4>
    </router-link>
  </article>
</template>

<script>
export default {
  name: "HomeCategoreis_card",

  props: {
    data: Object,
  },
};
</script>
<style scoped>
.card-categorei {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
}

.card-categorei-title {
  /*   position: absolute;*/
  bottom: 3%;
  /* background-color: #fff;*/
  text-align: center;
  color: #000;
  left: 50%;
  /*transform: translateX(-50%);*/
  padding: 6px 24px;
  border-radius: 0.75rem;
  font-size: 17px;
  line-height: 28px;
  font-weight: 600;
  transition: all 0.5s;
}
.card-categorei img {
  transition: all 0.5s;
  border-radius: 16px;
  width: 100% !important;

  /* background-color: #fff;*/
}
.card-categorei:hover.card-categorei img {
  transform: scale(1.2);
}
/*.card-categorei-title:hover{
    background-color: #000;
    color: #fff;
}*/
@media screen and (max-width: 639px) {
  .card-categorei-title {
    padding: 2px 20px;
    font-size: 14px;
  }
}
@media screen and (max-width: 360px) {
  .card-categorei-title {
    padding: 4px 20px;

    font-size: 14px;
  }
}
</style>
